<template>
  <div class="introduction-container" :class="device.isMobile ? 'introduction-container-mobile' : ''" :id="content.key">
    <div :id="`${content.key}-1`" class="introduction-content">
      <div class="introduction-back"></div>
      <div class="introduction-list">
        <div
          class="item"
          v-for="(item, index) in pageData"
          :key="item.key"
          :class="rotateActive || item.rotateActive ? 'active' : ''"
          @click.stop="rotateHandle(item, index)"
        >
          <div v-if="item.key">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-details">
              <span v-for="(item, index) in item.details" :key="index">{{ item }}</span>
            </div>
            <div class="item-info">
              {{ item.info }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <p
      class="introduction-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.titleStyle.fontFamily || '',
        fontSize: (content.titleStyle.fontSize + 'rem') || '',
        lineHeight: (content.titleStyle.lineHeight + 'rem') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.titleStyle.fontWeight || '',
        textDecoration: content.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.titleStyle.textAlign || '',
        color: content.titleStyle.color || '',
        backgroundColor: content.titleStyle.backgroundColor || '',
      }"
      v-html="content.title"
    ></p>
  </div>
</template>

<script>
/*
详情介绍模块
*/
export default {
  name: "introduction",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      pageData: [],
      rotateActive: false,
      rotateTimer: null,
    }
  },
  mounted() {
    this.pageData = this.content.content
    if(this.pageData[1].key) {
      this.pageData.splice(1, 0, {}); // 在索引为1的位置添加元素
    }
    this.rotateTimer = setInterval(() => {
      this.rotateActive = !this.rotateActive
    }, 5000)
  },
  beforeDestroy() {
    this.clearRotateTimer()
  },
  methods: {
    rotateHandle(item, index) {
      this.clearRotateTimer();
      if(this.rotateActive) {
        this.pageData.map(data => {
          data.rotateActive = this.rotateActive;
          return data
        })
        this.rotateActive = false
      }
      // this.pageData[index].rotateActive = !this.pageData[index].rotateActive
      item.rotateActive = !item.rotateActive
      this.pageData.splice(index, 1, item); // 替换元素
      console.log(this.pageData)
      // this.rotateActive = !this.rotateActive
    },
    clearRotateTimer() {
      clearInterval(this.rotateTimer);
      this.rotateTimer = null
    },
  },
}
</script>

<style lang="scss" scoped>
.introduction-container{
  width: 100%;
  margin: 30rem auto;
  .introduction-content{
    width: 100%;
    background: rgba(255,255,255,0.7);
    border-radius: 10rem;
    padding: 27rem;
    position: relative;
  
    .introduction-back{
      width: 180rem;
      height: 137rem;
      position: absolute;
      top: 26rem;
      left: 50%;
      margin-left: -90rem;
      background: url(~@/assets/images/books/bookExample/introduction-icon.png) center center no-repeat;
      background-size: contain;
    }
  
    .introduction-list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
  
      .item{
        width: 220rem;
        margin-top: 42rem;
  
        >div{
          width: 220rem;
          height: 120rem;
          position: relative;
        }
  
        .item-title{
          width: 100rem;
          height: 36rem;
          background: #4B96D1;
          border-radius: 18rem;
          line-height: 36rem;
          font-size: 18rem;
          color: #fff;
          text-align: center;
          position: absolute;
          left: 50%;
          margin-left: -50rem;
          margin-top: -18rem;
          z-index: 5;
        }
  
        .item-details{
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          align-items: center;
          padding: 28rem 20rem 15rem;
          background: #e3eff9;
          border: 1rem solid #e3eff9;
          border-radius: 18rem;
          overflow: hidden;
          box-sizing: border-box;
  
          span{
            font-size: 18rem;
            line-height: 38rem;
            color: #333;
          }
        }
  
        .item-info{
          position: absolute;
          width: 100%;
          height: 100%;
          display: none;
          font-size: 18rem;
          line-height: 24rem;
          padding: 25rem 10rem 22rem;
          background: #fff;
          border: 1rem solid #4B96D1;
          border-radius: 20rem;
          overflow: hidden;
          box-sizing: border-box;
        }
        
        &:nth-child(2){
          >div{
            display: none;
          }
        }
      }
  
      .item:hover{
        >div{
        }
        .item-details{
          display: none;
        }
  
        .item-info{
          display: block;
        }
      }
      
    }
  }

  .introduction-title{
    display: block;
    margin-top: 15rem;
    width: 100%;
    text-align: center;
    font-size: 16rem;
    line-height: 20rem;
    color: #666;
    white-space: pre-wrap;
  }
}

.introduction-container-mobile{
  margin: 60rem auto;
  .introduction-content{
    .introduction-list{
      .item{
        >div{
          width: 220rem;
          height: 120rem;
          position: relative;
          backface-visibility: hidden;
        }
  
        .item-details{
          z-index: 3;
          transition: transform 0.6s;
  
          span{
            font-size: 18rem;
            line-height: 38rem;
            color: #333;
          }
        }
  
        .item-info{
          width: 99%;
          display: block;
          font-size: 18rem;
          line-height: 24rem;
          padding: 25rem 8rem 22rem;
          transform: rotateY(180deg);
          transition: transform 0.6s;
          z-index: 2;
        }
      }
      
      .item:hover {
        .item-details {
          display: flex;
        }
        .item-info{
          display: block;
        }
      }
      .item.active {
        .item-details {
          display: flex;
          transform: rotateY(180deg);
          z-index: 2;
        }
        .item-info{
          display: block;
          transform: rotateY(360deg);
          z-index: 3;
        }
      }
    }
  }
  .introduction-title{
    font-size: 20rem;
    margin-top: 24rem;
  }
}
</style>